import { types, Instance } from "mobx-state-tree";
import React, { useContext, createContext } from "react";
import { AuthStore } from "./authStore";
import { ProjectStore } from "./projectStore";
import {CompositionStore} from './compositionsStore';
import { RenderStore } from './renderStore'
import {UIStore} from './UIStore'
export const RootModel = types.model({
  authStore: AuthStore,
  renderStore: RenderStore,
  projectStore: ProjectStore,
  compositionStore: CompositionStore,
  uiStore: UIStore,
});

export const rootStore = RootModel.create({
  authStore: {},
  projectStore: {},
  compositionStore: {},
  renderStore: {},
  uiStore: {},
});

export const MSTContext = React.createContext(rootStore);

export type RootInstance = Instance<typeof RootModel>;

const RootStoreContext = createContext<null | RootInstance>(null);

export const Provider = RootStoreContext.Provider;

export function useMst(): RootInstance {
  const store = useContext(RootStoreContext);
  if (store === null) {
    throw new Error("Store cannot be null, please add a context provider");
  }
  return store;
}
